export const ACTIVE = 2;
export const LOCKED = 3;
export const BREAK = 7;
